import { createSelector } from 'reselect';
import { fetchSubcategoriesByCategoryID } from '@/redux/api/subcategoryTiles';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_SUBCATEGORY_TILES_FAIL = 'la/domain/items/LOAD_SUBCATEGORY_TILES_FAIL';
export const LOAD_SUBCATEGORY_TILES_SUCCESS = 'la/domain/items/LOAD_SUBCATEGORY_TILES_SUCCESS';

interface DefaultState {
    subcategoryTiles: {
        categoryId: string;
        imageURL: string;
        label: string;
        lotCount: number;
        url: string;
    }[];
}

/* reducer */
const DEFAULT_STATE: DefaultState = {
    subcategoryTiles: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_SUBCATEGORY_TILES_FAIL:
            return {
                ...state,
                subcategoryTiles: [],
            };
        case LOAD_SUBCATEGORY_TILES_SUCCESS:
            return {
                ...state,
                subcategoryTiles: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.subcategoryTiles;

export const getSubcategoryTiles = createSelector(stateSelector, (state) => {
    return state.subcategoryTiles.filter((categoryTile) => Number(categoryTile.lotCount) > 0) || [];
});

/* ACTION CREATORS */
export const fetchSubcategories = (categoryId: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);
    if (!categoryId) {
        return;
    }
    try {
        const response = await fetchSubcategoriesByCategoryID({ categoryId, deployment });
        const subcatsInNumLotsOrder = response.payload.sort((a, b) => {
            return b.lotCount - a.lotCount;
        });
        dispatch({
            payload: subcatsInNumLotsOrder,
            type: LOAD_SUBCATEGORY_TILES_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { categoryId },
            payload: error,
            type: LOAD_SUBCATEGORY_TILES_FAIL,
        });
    }
};
